import * as React from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@shigo-ui/ui';

import { dashboardT } from '../../../../lib/messages';
import type { Creative, CreativeVariant } from '../model';
import { CreativeVariantsList } from './CreativeVariantsList';

export function CreativeVariantsDialog({
  creative,
  saving,
  onOpenChange,
  onSave,
}: {
  creative: Creative | null;
  saving: boolean;
  onOpenChange: (open: boolean) => void;
  onSave: (variants: CreativeVariant[]) => void;
}) {
  const [variants, setVariants] = React.useState<CreativeVariant[]>(
    () => creative?.variants.map((variant) => ({ ...variant })) ?? [],
  );
  return (
    <Dialog open={Boolean(creative)} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{dashboardT('creatives.variants')}</DialogTitle>
        </DialogHeader>
        <CreativeVariantsList
          variants={variants}
          onToggle={(index, active) => {
            setVariants((current) =>
              current.map((item, itemIndex) => (itemIndex === index ? { ...item, active } : item)),
            );
          }}
        />
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            disabled={saving}
            onClick={() => {
              onOpenChange(false);
            }}
          >
            {dashboardT('creatives.cancel')}
          </Button>
          <Button
            type="button"
            disabled={saving}
            onClick={() => {
              onSave(variants);
            }}
          >
            {saving ? dashboardT('creatives.saving') : dashboardT('creatives.save')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
